import { Component, computed, effect, inject, signal, untracked, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RendererDirective } from '../../core/dynamic/renderer';

import { Menu, MenuItem, MenuView } from '../../model';
import { ViewSignal, MenuSignal, MemberSignal } from '../../signal';

@Component({
    selector: 'app-menu',
    imports: [CommonModule, MatIconModule, RendererDirective],
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MenuComponent {
    private readonly viewSignal = inject(ViewSignal);
    private readonly menuSignal = inject(MenuSignal);
    private readonly memberSignal = inject(MemberSignal);

    menu = computed(() => this.viewSignal.menu());

    start = signal(false);
    selected = signal(false);

    dimmed = computed(() => !this.start());

    top = 0;

    isOpen(item: MenuItem) {
        return this.menuSignal.item() === item;
    }

    constructor() {
        effect(() => {
            const menu = this.menu();

            if (menu?.items) {
                this.start.set(false);
            }
        });

        effect(() => {
            const member = this.memberSignal.member();
            const menu = untracked(() => this.menu());
            if (menu?.items) {
                new MenuView(menu).applyMember(member);
                this.menuSignal.item.set(undefined);
            }
        });
    }

    onToggle() {
        const next = !this.start();

        this.start.set(next);

        this.menuSignal.item.set(undefined);
        this.menuSignal.toggle.set(next);
    }

    onSelect(item: MenuItem) {
        this.menuSignal.item.update(current => current === item ? undefined : item);
    }
}
